module.exports = __webpack_public_path__ + "media/images/sagatsuku-kun_pc-f9519ef2dcd1025f5653d606f1af9f94.png";